import { HttpService } from '@/infra/http'

export type TGetBlocosDisponiveisResponse = Array<{
  id: string
  nome: string
  idExterno: number
}>

export class GetBlocosDisponiveisService extends HttpService {
  execute = async (empreendimentoId: string) => {
    return this.http.get<TGetBlocosDisponiveisResponse>(`/api/v2/Bloco/empreendimento/${empreendimentoId}/disponiveis`)
  }
}
